
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {
    useAuth
} from "../context/AuthContext";
import {
FaChartBar,
FaSuitcase,
FaCalendar,
FaUsers,
FaDollarSign,
FaSignOutAlt,
FaCalendarCheck,
FaEnvelope,
FaUserShield,
FaBars,
FaTimes,
FaAngleDoubleLeft,
FaAngleDoubleRight
} from "react-icons/fa";

import logo from "../assets/logo.png";


export default function AdminLayout({ children }) {
const {
    
    loading,
    hasPermission
} = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {

    return localStorage.getItem("adminSidebar") === "collapsed";

});

const [isMobile, setIsMobile] = useState(
    window.innerWidth < 900
);

useEffect(() => {

    const resize = () => {

        setIsMobile(
            window.innerWidth < 900
        );

    };

    window.addEventListener(
        "resize",
        resize
    );

    return () =>
        window.removeEventListener(
            "resize",
            resize
        );

}, []);

  const menu = [

    {
        key: "dashboard",
        label: "Dashboard",
        icon: <FaChartBar />,
        permission: "view_dashboard"
    },

    {
        key: "tours",
        label: "Tours",
        icon: <FaSuitcase />,
        permission: "manage_tours"
    },

   {
    key: "bookings",
    label: "Bookings",
    icon: <FaCalendar />,
    permission: "manage_bookings"
},

{
    key: "revenue",
    label: "Revenue",
    icon: <FaDollarSign />,
    permission: "view_revenue"
},

{
    key: "email",
    label: "Email",
    icon: <FaEnvelope />,
    permission: "manage_email"
},

    {
        key: "guides",
        label: "Guides",
        icon: <FaUsers />,
        permission: "manage_guides"
    },

    {
        key: "users",
        label: "Users & Permissions",
        icon: <FaUserShield />,
        permission: "manage_users"
    }

];

const visibleMenu =
    menu.filter(item =>
        hasPermission(
            item.permission
        )
    );


const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("user");

    if (isMobile) {
        setMobileMenuOpen(false);
    }

    navigate("/login");
};


  return (

    <div style={layout}>

    {
    isMobile && (

        <div style={mobileHeader}>

            <button
                style={menuButton}
                onClick={() =>
                    setMobileMenuOpen(!mobileMenuOpen)
                }
            >
                {
                    mobileMenuOpen
                        ? <FaTimes />
                        : <FaBars />
                }
            </button>

           <img
    src={logo}
    alt="Company Logo"
    style={{
        height: 42,
        width: "auto",
        marginLeft: 16
    }}
/>

        </div>

    )
}

   





      {/* =====================================================
          SIDEBAR
      ===================================================== */}
<div
    className="sidebar"
    style={{

        ...sidebar,

        width: sidebarCollapsed ? 80 : 260,

        left:

            isMobile

                ?

                mobileMenuOpen

                    ?

                    0

                    :

                    -300

                :

                0

    }}
>

 
        {/* ================= BRAND ================= */}

       <div style={brand}>

    <img
        src={logo}
        alt="Company Logo"
        style={{
            width:
                sidebarCollapsed
                    ? 52
                    : 220,
            transition: ".25s",
            display: "block",
            margin: "0 auto"
        }}
    />

    {

        !sidebarCollapsed && (

            <p
                style={{
                    fontSize:22,
                    fontWeight:800,
                    textAlign:"center",
                    marginTop:5,
                    color:"#111827",
                    letterSpacing:1,
                    textTransform:"uppercase"
                }}
            >

                Admin Portal

            </p>

        )

    }

</div>


        {/* =================================================
            NAVIGATION
        ================================================= */}

        <div style={nav}>

          {visibleMenu.map(item => {

            const isActive =
              location.pathname.includes(
                `/admin/${item.key}`
              );


              if (loading) {

    return (

        <div style={{
            padding: 40
        }}>

            Loading...

        </div>

    );

}

            return (

              <div
                key={item.key}

                onClick={() => {

                  if (
                    item.key ===
                    "guide-availability"
                  ) {

                    window.open(
                      "/admin/guide-availability",
                      "_blank"
                    );

                  } else {

                   navigate(
`/admin/${item.key}`
);

if(isMobile){

setMobileMenuOpen(false);

}

                  }

                }}

                style={{

    ...navItem,

    gap:
        sidebarCollapsed
            ? 0
            : 12,

    justifyContent:
        sidebarCollapsed
            ? "center"
            : "flex-start",

    background:
        isActive
            ? "#f3841c"
            : "transparent",

    color:
        isActive
            ? "black"
            : "#000000"

}}

              >

                {item.icon}

               {
    !sidebarCollapsed && (

        <span>

            {item.label}

        </span>

    )
}

              </div>

            );

          })}

        </div>


<div

style={{

    height:1,

    background:"rgba(255,255,255,.15)",

    margin:"16px 0"

}}

/>

<div
    style={collapseButton}
    onClick={() => {

        const next = !sidebarCollapsed;

        setSidebarCollapsed(next);

        localStorage.setItem(
            "adminSidebar",
            next
                ? "collapsed"
                : "expanded"
        );

    }}
>

    {

        sidebarCollapsed

            ?

            <FaAngleDoubleRight />

            :

            <FaAngleDoubleLeft />

    }

</div>


        {/* =================================================
            LOGOUT
        ================================================= */}

        <div style={footer}>

          <div
            style={{

...logout,

justifyContent:

sidebarCollapsed

?

"center"

:

"flex-start"

}}

            onClick={handleLogout}
            

            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                "#000000";
            }}

            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                "#111827";
            }}

          >

            <FaSignOutAlt />

{

    !sidebarCollapsed &&

    "Logout"

}

          </div>

        </div>

      </div>

 {
    isMobile &&
    mobileMenuOpen && (

        <div
            style={overlay}
            onClick={() =>
                setMobileMenuOpen(false)
            }
        />

    )
}
      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <div
    style={{
        flex: 1,
        background: "#ebebeb",
        overflowY: "auto",
        padding: isMobile ? "80px 15px 20px" : "25px",
        marginLeft:

isMobile

?

0

:

sidebarCollapsed

?

80

:

260,
transition:"margin-left .32s cubic-bezier(.4,0,.2,1)"
    }}
>

        {children}

      </div>

    </div>

  );

}


/* =========================================================
   STYLES
========================================================= */


const layout = {

    minHeight: "100vh",

    background: "#ebebeb"

};


const sidebar = {
    width: 260,
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 1002,   // <- higher than overlay
    transition:"left .32s cubic-bezier(.4,0,.2,1), width .32s cubic-bezier(.4,0,.2,1)",
    boxSizing: "border-box",
    background: "#c75028",
    color: "white",
    display: "flex",
    flexDirection: "column",
    padding: 20,
    overflowY: "auto"
};

const brand = {

  marginBottom: "20px",

  flexShrink: 0

};


const nav = {

  display: "flex",

  flexDirection: "column",

  gap: "8px",

  flex: 1,

  overflowY: "auto"

};


const navItem = {

    display:"flex",

    alignItems:"center",

    gap:12,

    justifyContent:"flex-start",

    padding:"10px 12px",

    borderRadius:10,

    cursor:"pointer",

    transition:".2s",

    fontSize:14

};


const footer = {

  marginTop: "15px",

  flexShrink: 0

};


const logout = {

  display: "flex",

  alignItems: "center",

  gap: "10px",

  color: "white",

  cursor: "pointer",

  padding: "10px 12px",

  borderRadius: "10px",

  background: "#111827",

  transition: "0.2s"

};




const mobileHeader = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 64,
    background: "white",
    display: "flex",
    alignItems: "center",
    padding: "0 18px",
    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
    zIndex: 1003
};

const menuButton={

border:"none",

background:"transparent",

fontSize:24,

cursor:"pointer",

display:"flex",

alignItems:"center"

};

const overlay = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,.45)",
    zIndex: 1001
};

const collapseButton = {

    display:"flex",

    justifyContent:"center",

    alignItems:"center",

    height:44,

    cursor:"pointer",

    borderRadius:12,

    background:"rgba(0,0,0,.12)",

    color:"white",

    marginTop:18,

    marginBottom:18,

    transition:"all .2s ease",

    fontSize:18,

    flexShrink:0

};